import React, { Component } from 'react';
import { Switch, Route, HashRouter } from 'react-router-dom';
import "./membership.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import ReactHtmlParser from 'react-html-parser';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import DeleteModal from 'LIBRARY/CommonResources/DeleteModal/DeleteModal';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import Pagination from 'react-js-pagination';
import { getLibraryAccessDetails, setAssignedInstitute } from 'LIBRARY/Actions/AdminDetailsAction.js';
import moment from 'moment';
import { connect } from 'react-redux';
import SpecificUserLog from 'LIBRARY/CommonResources/SpecificUserLog/SpecificUserLog';

class Membership extends Component {


    constructor(props) {
        super(props);
        this.state = {
            addMember: false,
            filterModal: false,
            selectedRole: '',
            acaYear: config.instructorInfo.AcaYear,
            selectedSemester: '',
            semesterList: {},
            facultyDepartment: {},
            facultyStream: "",
            employeeList: {},
            studentList: {},
            selectedGroupId: '',
            validFromDate: '',
            validToDate: '',
            showListTable: '',

            // VARIABLES TO SEARCH BY FILTERS
            searchMemberStatus: '',
            searchMemberUserID: '',
            searchMemberRole: '',
            searchMemberAcaYr: '',
            searchMemberDepartment: '',
            searchMemberGroup: '',
            filterApplied: false,
            isAcaYrEmpty: false,

            //VARIABLES TO UPDATE MEMBERSHIP
            updateValidFromDate: '',
            updateValidToDate: '',

            offset: 0,
            pageIndex: 1,
            limit: 10,
            accessDataList: false,
            successModal: false,

            // VARIABLES TO SELECT FACULTY
            selectedFacultyIds: [],

            // VARIABLES TO SELECT FACULTY
            selectedStudentIds: [],

            // VARIABLES TO SELECT FACULTY
            selectedMemberIds: [],

            showValidDates: false,
            isDateEmpty: false,

            //VARIABLE TO GET MEMBERS LIST
            membersList: {},
            totalMembers: 0,
            renewMembershipModal: false,
            accessMemberList: false,

            showActivitySlider: false,
            selectedIid:"",
            hoverID:"",
        }
    }

    componentDidMount() {
        this.apiCallToGetLibraryMembersList();
        this.GetInstituteStreamsObject();
    }

    // API CALL TO GET FACULTY STREAM DATA LIST
    GetInstituteStreamsObject = async () => {
        let requestData = {
            "iid": config.institute_id,
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteStreamsObject',
            requestData,
            "/api/admission/streamManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetInstituteStreamsObject();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.setState({
                        facultyDepartment: apiResult.data
                    })
                }
                else {
                    this.setState({
                        facultyDepartment: {},
                    })
                }
            } else {
                this.setState({
                    facultyDepartment: {},
                })
            }
        }
    }

    // API CALL TO GET GROUP DATA LIST
    apiCallToGetSemesterDetails = async (action) => {

        let departmentID;
        let acaYrId;

        if (action == "add") {
            departmentID = this.state.selectedSemester;
            acaYrId = this.state.acaYear
        } else {
            departmentID = this.state.searchMemberDepartment;
            acaYrId = this.state.searchMemberAcaYr
        }

        let requestData = {
            "acayr": acaYrId,
            "sid": departmentID,
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'group_getActiveGroupWithEvenOddDisplayType',
            requestData,
            "/api/admission/groupDetails.php"
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetSemesterDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                if (apiResult.success == 'true') {
                    this.setState({
                        semesterList: apiResult.data,
                    })
                }
                else {
                    this.setState({
                        semesterList: {}
                    })
                }
            }
        }
    }

    // API CALL TO GET EMPLOYEE DATA LIST
    apiCallToGetEmployeeDetails = async () => {

        this.setState({
            accessDataList: true
        });

        let requestData = {
            "institute_id": config.institute_id,
            "department": this.state.facultyStream,
            "search": ""
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getEmployeeDetails',
            requestData,
            "/api/employee/employee.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetEmployeeDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.setState({
                        employeeList: apiResult.data,
                        accessDataList: false,

                    })
                }
                else {
                    this.setState({
                        employeeList: {},
                        accessDataList: false,

                    })
                }
            } else {
                this.setState({
                    employeeList: {},
                    accessDataList: false,

                })
            }
        }
    }

    // API CALL TO GET STUDENT DATA LIST
    apiCallToGetStudentDetails = async () => {

        this.setState({
            accessDataList: true
        });

        let requestData = {
            "institute_id": config.institute_id,
            "sid": this.state.selectedSemester,
            "aca_yr": this.state.acaYear,
            "group_id": this.state.selectedGroupId,
        }
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'admissionGetAllStudentList',
            requestData,
            "/api/admission/groupDetails.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetStudentDetails();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.setState({
                        studentList: apiResult.data,
                        accessDataList: false,

                    })
                }
                else {
                    this.setState({
                        studentList: {},
                        accessDataList: false,

                    })
                }
            } else {
                this.setState({
                    studentList: {},
                    accessDataList: false,

                })
            }
        }
    }

    // API CALL METHOD TO ADD CALL NUMBER SERIES
    apiCallToAddLibraryMembers = async (role, streamId, userIds) => {

        let requestData = {
            "iid": config.institute_id,
            "role": role,
            "userIdArray": userIds,
            "sid": streamId,
            "aca_year": this.state.acaYear,
            "group_id": this.state.selectedGroupId,
            "validFrom": this.state.validFromDate,
            "validTo": this.state.validToDate,
            "added_by": config.faculty_id
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'addLibraryMembers',
            requestData,
            '/api/library/libraryMembership.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToAddLibraryMembers()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == 'success') {

                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: ReactHtmlParser(apiResult.message),
                    }, () => {
                        this.closeAddMember();
                        this.apiCallToGetLibraryMembersList();
                    });
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while adding members. Please try again later.',
                });
            }
        }
    }

    // API CALL TO GET MEMBERS DATA LIST
    apiCallToGetLibraryMembersList = async () => {

        this.setState({
            accessMemberList: true
        });

        let requestData = {
            "iid": config.institute_id,
            "pageIndex": this.state.pageIndex,
            "limitPerPage": this.state.limit,
            "filter_userId": this.state.searchMemberUserID,
            "filter_role": this.state.searchMemberRole,
            "filter_acaYr": this.state.searchMemberAcaYr,
            "filter_sid": this.state.searchMemberDepartment,
            "filter_groupId": this.state.searchMemberGroup,
            "filter_status": this.state.searchMemberStatus
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getLibraryMembersList',
            requestData,
            "/api/library/libraryMembership.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetLibraryMembersList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.success == 'true') {

                    this.setState({
                        membersList: apiResult.data,
                        totalMembers: apiResult.total,
                        accessMemberList: false,
                        addMember: false
                    })
                }
                else {
                    this.setState({
                        membersList: {},
                        totalMembers: 0,
                        accessMemberList: false,

                    })
                }
            } else {
                this.setState({
                    membersList: {},
                    totalMembers: 0,
                    accessMemberList: false,

                })
            }
        }
    }

    // API CALL METHOD TO UPDATE CALL NUMBER SERIES
    apiCallToUpdateLibraryMembership = async (validFrom, validTo, uniqueIds) => {

        let requestData = {
            "iid": config.institute_id,
            "unique_ids": uniqueIds,
            "valid_from": validFrom,
            "valid_to": validTo,
            "updated_by": config.faculty_id
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'updateLibraryMembership',
            requestData,
            '/api/library/libraryMembership.php'

        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToUpdateLibraryMembership(validFrom, validTo, uniqueIds)
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult.status == 'success') {
                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        renewMembershipModal: false,
                        selectedMemberIds: [],
                        updateValidFromDate: '',
                        updateValidToDate: '',
                        successMessage: ReactHtmlParser(apiResult.message),
                    }, () => this.apiCallToGetLibraryMembersList());
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while updating membership. Please try again later.',
                });
            }
        }
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    // METHOD TO CLOSE RENEW MODAL
    closeRenewModal = () => {
        this.setState({
            renewMembershipModal: false,
            updateValidFromDate: '',
            updateValidFromDate: '',
            isDateEmpty: false,
        });
    }

    handleRoleChange = (e) => {
        this.setState({
            selectedRole: e.target.value,
            showListTable: '',
            selectedFacultyIds: [],
            selectedStudentIds: [],
            acaYear: config.instructorInfo.AcaYear,
            selectedSemester: '',
            selectedGroupId: '',
            facultyStream: '',
            validFromDate: '',
            validToDate: '',
        }, () => { this.GetInstituteStreamsObject(); });

    }

    // METHOD TO CHECK ACCESS FOR ADD OPERATION
    checkAddMember = () => {
        const addGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['membership'].find(access => access === 'add');

        if (addGrantAccess !== undefined) {
            this.setState({
                addMember: true
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    // METHOD TO SELECT LIMIT
    selectLimit = (e) => {
        this.setState({
            limit: e.target.value,
            pageIndex: 1,
            offset: 0,
        }, () => {
            // METHOD CALLED TO GET MEMBER DETAILS
            this.apiCallToGetLibraryMembersList();
        });
    }

    // METHOD TO UPDATE PAGINATION PAGE NUMBER
    updatePaginationCount = (pageNumber) => {
        this.setState({
            pageIndex: pageNumber,
            offset: (pageNumber - 1) * this.state.limit,
            selectedMemberIds: []
        }, () => {
            // METHOD CALLED TO GET MEMBER DETAILS
            this.apiCallToGetLibraryMembersList();
        });
    }

    // METHOD TO CLOSE ADD MEMBER MODAL
    closeAddMember = () => {
        this.setState({
            addMember: false,
            showListTable: '',
            selectedRole: '',
            selectedFacultyIds: [],
            selectedStudentIds: [],
            acaYear: config.instructorInfo.AcaYear,
            selectedSemester: '',
            selectedGroupId: '',
            validFromDate: '',
            validToDate: '',
        });
    }

    //METHOD TO CLOSE ADVANCED FILTER MODAL
    closeAdvancedFilter = () => {
        this.setState({
            filterModal: false,
            searchMemberRole: '',
            searchMemberAcaYr: '',
            searchMemberDepartment: '',
            searchMemberGroup: '',
            searchMemberStatus: '',
            searchMemberUserID: ''
        });
    }

    handleStatusChange = (e) => {
        this.setState({
            searchMemberStatus: e.target.value
        });

    }

    // METHOD TO SELECT ALL EMPLOYEES
    selectAllEmployees = (e) => {
        let facultySet = new Set();

        if (e.target.checked) {
            if (Object.keys(this.state.employeeList).length > 0) {
                Object.keys(this.state.employeeList).map(employeeId => {
                    facultySet.add(employeeId);
                });
            }
            this.setState({
                showValidDates: true,
            });
        } else {
            this.setState({
                showValidDates: false,
                validFromDate: '',
                validToDate: '',
                isDateEmpty: false
            });
        }

        this.setState({
            selectedFacultyIds: Array.from(facultySet),
        });
    }

    // METHOD TO SELECT SINGLE EMPLOYEE
    selectSingleEmployee = (employeeId) => {

        let selectedFacultyIds = this.state.selectedFacultyIds;

        if (selectedFacultyIds.includes(employeeId)) {
            selectedFacultyIds = selectedFacultyIds.filter(id => id != employeeId);
        } else {
            selectedFacultyIds.push(employeeId);
        }

        if (selectedFacultyIds.length > 0) {
            this.setState({
                showValidDates: true,
            });
        } else {
            this.setState({
                showValidDates: false,
                validFromDate: '',
                validToDate: '',
                isDateEmpty: false
            });
        }

        this.setState({
            selectedFacultyIds,
        });

    }

    // METHOD TO SELECT ALL STUDENTS
    selectAllStudents = (e) => {
        let studentSet = new Set();

        if (e.target.checked) {
            if (Object.keys(this.state.studentList).length > 0) {
                Object.keys(this.state.studentList).map(studentId => {
                    studentSet.add(studentId);
                });
            }
            this.setState({
                showValidDates: true,
            });
        } else {
            this.setState({
                showValidDates: false,
                validFromDate: '',
                validToDate: '',
                isDateEmpty: false
            });
        }

        this.setState({
            selectedStudentIds: Array.from(studentSet),
        });
    }

    // METHOD TO SELECT SINGLE STUDENT
    selectSingleStudent = (studentId) => {

        let selectedStudentIds = this.state.selectedStudentIds;

        if (selectedStudentIds.includes(studentId)) {
            selectedStudentIds = selectedStudentIds.filter(id => id != studentId);
        } else {
            selectedStudentIds.push(studentId);
        }

        if (selectedStudentIds.length > 0) {
            this.setState({
                showValidDates: true,
            });
        } else {
            this.setState({
                showValidDates: false,
                validFromDate: '',
                validToDate: '',
                isDateEmpty: false
            });
        }

        this.setState({
            selectedStudentIds,
        });

    }

    //METHOD TO VALIDATE TO REGISTER NEW MEMBER
    validateMembers = () => {

        let role = '';
        let streamId = '';
        let userIds = [];

        if (this.state.selectedRole == "student") {
            role = "student";
            streamId = this.state.selectedSemester;
            userIds = this.state.selectedStudentIds;
        }
        else if (this.state.selectedRole == "faculty") {
            role = "faculty";
            streamId = this.state.facultyStream;
            userIds = this.state.selectedFacultyIds;
        }

        if (
            !this.state.validFromDate.length ||
            !this.state.validToDate.length ||
            this.state.validToDate < this.state.validFromDate
        ) {
            this.setState({ isDateEmpty: true });
            return;
        }

        this.apiCallToAddLibraryMembers(role, streamId, userIds);

    }

    // METHOD TO SELECT ALL MEMBERS
    selectAllMembers = (e) => {
        let memberSet = new Set();

        if (e.target.checked) {
            if (Object.keys(this.state.membersList).length > 0) {
                Object.keys(this.state.membersList).map(employeeId => {
                    memberSet.add(employeeId);
                });
            }
            this.setState({
                showValidDates: true,
            });
        } else {
            this.setState({
                showValidDates: false,
                validFromDate: '',
                validToDate: '',
                isDateEmpty: false
            });
        }

        this.setState({
            selectedMemberIds: Array.from(memberSet),
        });
    }

    // METHOD TO SELECT SINGLE EMPLOYEE
    selectSingleMember = (memberId) => {

        let selectedMemberIds = this.state.selectedMemberIds;

        if (selectedMemberIds.includes(memberId)) {
            selectedMemberIds = selectedMemberIds.filter(id => id != memberId);
        } else {
            selectedMemberIds.push(memberId);
        }

        if (selectedMemberIds.length > 0) {
            this.setState({
                showValidDates: true,
            });
        } else {
            this.setState({
                showValidDates: false,
                validFromDate: '',
                validToDate: '',
                isDateEmpty: false
            });
        }

        this.setState({
            selectedMemberIds,
        });

    }

    // METHOD TO VALIDATE TO RENEW MEMBERSHIP
    validateRenewMembership = () => {

        let validFrom = this.state.updateValidFromDate;
        let validTo = this.state.updateValidToDate;
        let uniqueIds = this.state.selectedMemberIds;

        if (
            !this.state.updateValidFromDate.length ||
            !this.state.updateValidToDate.length ||
            this.state.updateValidToDate < this.state.updateValidFromDate
        ) {
            this.setState({ isDateEmpty: true });
            return;
        }

        this.apiCallToUpdateLibraryMembership(validFrom, validTo, uniqueIds);

    }

    // METHOD TO APPLY ADVANCED FILTERS
    applyAdvancedFilter = () => {

        this.setState({
            filterModal: false,
            pageIndex: 1,
            offset: 0,
            filterApplied: true
        }, () => this.apiCallToGetLibraryMembersList());
    }

    // METHOD TO HANDLE ROLE CHANGE FOR FILTERS
    filterRoleChange = (e) => {
        this.setState({
            searchMemberRole: e.target.value,
            searchMemberAcaYr: '',
            searchMemberDepartment: '',
            searchMemberGroup: '',

        }, () => { this.GetInstituteStreamsObject(); });
    }

    // METHOD TO CLEAR FILTER
    clearFilter = () => {
        this.setState({
            searchMemberRole: '',
            searchMemberAcaYr: '',
            searchMemberDepartment: '',
            searchMemberGroup: '',
            searchMemberStatus: '',
            searchMemberUserID: '',
            filterApplied: false,
            pageIndex: 1,
            offset: 0
        }, () => this.apiCallToGetLibraryMembersList());
    }

    // METHOD TO RETURN REGISTER NEW MEMBER
    returnRegisterNewMember = () => {
        return (
            <div id="addAccessSideMenu" style={{ display: this.state.addMember ? 'flex' : 'none' }}>
                <div id="addMemberDataContainer">
                    <div id="addAccessHeader" className="row">
                        <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#000" onClick={() => this.closeAddMember()} style={{ cursor: "pointer" }} />
                        <h5 style={{ paddingLeft: '30%' }} className="col-11">Register New Member</h5>
                    </div>
                    <div>
                        <div className="col-md-12 pt-2">
                            <div className="row">
                                <div className="col-md-6">
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>Role <span style={{ color: 'red' }}> *</span></label>

                                    <select className="form-control"
                                        // style={{ height: '4vh' }}
                                        name="role"
                                        id="role"
                                        value={this.state.selectedRole}
                                        onChange={this.handleRoleChange}
                                    >
                                        <option value="">Select Role</option>
                                        <option value="student">Student</option>
                                        <option value="faculty">Faculty</option>
                                    </select>
                                </div>
                                <div className="col-md-6 ">

                                    {
                                        this.state.selectedRole == 'student' && (

                                            <>
                                                <label style={{ fontWeight: "bold", fontSize: "14px" }}>Academic Year</label>

                                                <select className="form-control"
                                                    // style={{ height: '4vh' }}
                                                    value={this.state.acaYear}
                                                    onChange={(e) => { this.setState({ acaYear: e.target.value, selectedStudentIds: [] }) }}
                                                >
                                                    {
                                                        Object.values(config.academicInfo).map(acaYr => {
                                                            return (
                                                                <option value={acaYr.YearId}>{acaYr.YearText}</option>
                                                            );
                                                        })
                                                    }
                                                </select>
                                            </>
                                        )
                                    }
                                    {
                                        this.state.selectedRole == 'faculty' && (
                                            <>
                                                <label style={{ fontWeight: "bold", fontSize: "14px" }}>Department</label>

                                                <select className="form-control"
                                                    // style={{ height: '4vh' }}
                                                    value={this.state.facultyStream}
                                                    onChange={(e) => { this.setState({ facultyStream: e.target.value, showListTable: 'facultyList', selectedFacultyIds: [] }, () => { this.apiCallToGetEmployeeDetails(); }) }}
                                                >
                                                    <option value="">Select Department</option>
                                                    {
                                                        Object.keys(this.state.facultyDepartment).map(streams => {
                                                            let streamNames = this.state.facultyDepartment[streams]

                                                            return (
                                                                <option value={streams}>{streamNames.stream_name}</option>
                                                            );
                                                        })
                                                    }
                                                </select>

                                            </>
                                        )
                                    }
                                </div>

                            </div>
                        </div>
                        <div className="col-md-12 pt-4 pb-5">
                            <div className="row">
                                {
                                    this.state.selectedRole == 'student' && (

                                        <div className="col-md-6 ">
                                            <label style={{ fontWeight: "bold", fontSize: "14px" }}>Department</label>

                                            <select className="form-control"
                                                // style={{ height: '4vh' }}
                                                value={this.state.selectedSemester}
                                                onChange={(e) => { this.setState({ selectedSemester: e.target.value, selectedStudentIds: [] }, () => { this.apiCallToGetSemesterDetails("add"); }) }}
                                                disabled={!this.state.acaYear}
                                            >
                                                <option value="">Select Department</option>
                                                {
                                                    Object.keys(this.state.facultyDepartment).map(streams => {
                                                        let streamName = this.state.facultyDepartment[streams]

                                                        return (
                                                            <option value={streams}>{streamName.stream_name}</option>
                                                        );
                                                    })
                                                }
                                            </select>
                                        </div>
                                    )
                                }
                                {
                                    this.state.selectedRole == 'student' && (

                                        <div className="col-md-6">
                                            <label style={{ fontWeight: "bold", fontSize: "14px" }}>Group</label>

                                            <select className="form-control"
                                                // style={{ height: '4vh' }}
                                                value={this.state.selectedGroupId}
                                                onChange={(e) => { this.setState({ selectedGroupId: e.target.value, selectedStudentIds: [], showListTable: 'studentList' }, () => { this.apiCallToGetStudentDetails(); }) }}
                                                disabled={!this.state.selectedSemester}
                                            >
                                                <option value="">Select Group</option>
                                                {
                                                    Object.keys(this.state.semesterList).map(groupList => {
                                                        let groupName = this.state.semesterList[groupList]

                                                        return (
                                                            <option value={groupList}>{groupName.title}</option>
                                                        );
                                                    })
                                                }
                                            </select>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                        {this.state.showListTable != '' && (

                            <div className="col-md-12 " style={{ paddingLeft: '3%', paddingRight: '3%', maxHeight: '55vh', overflowY: 'scroll' }}>

                                {this.state.showListTable == 'facultyList' && (
                                    <table class="table jumbotron">
                                        <thead style={{ backgroundColor: "#f2f3f4", position: 'sticky', top: '-1%' }}>
                                            <tr>
                                                <th style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={Object.keys(this.state.employeeList).length > 0 && (Object.keys(this.state.employeeList).length == this.state.selectedFacultyIds.length)}
                                                        onChange={(e) => this.selectAllEmployees(e)}
                                                        style={{ marginRight: 5 }}
                                                    />
                                                </th>
                                                <th style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>Sr.No.</th>
                                                <th style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>ERP Id</th>
                                                <th style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>First Name</th>
                                                <th style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>Last Name</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                this.state.accessDataList ?
                                                    <tr>
                                                        <Spinner />
                                                    </tr>
                                                    :
                                                    Object.values(this.state.employeeList).length > 0 ?
                                                        Object.values(this.state.employeeList).map((employee, index) => {
                                                            let employeeId = employee.FacultyId

                                                            return (
                                                                <>
                                                                    <tr>
                                                                        <th style={{ paddingBottom: '4px' }}>
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={this.state.selectedFacultyIds.includes(employeeId.toString())}
                                                                                onChange={() => this.selectSingleEmployee(employeeId.toString())}
                                                                                style={{ marginRight: 5 }}
                                                                            />
                                                                        </th>
                                                                        <td className="tableRows">{this.state.offset + index + 1}</td>
                                                                        <td className="tableRows">{employee["usertextid"]}</td>
                                                                        <td className="tableRows">{employee["FirstName"]}</td>
                                                                        <td className="tableRows">{employee["LastName"]}</td>

                                                                    </tr>
                                                                </>
                                                            )
                                                        })
                                                        :
                                                        <tr>
                                                            <td colSpan={6}>Employee not found.</td>
                                                        </tr>
                                            }
                                        </tbody>
                                    </table>
                                )
                                }

                                {
                                    this.state.showListTable == 'studentList' && (
                                        <table class="table jumbotron">
                                            <thead style={{ backgroundColor: "#f2f3f4", position: 'sticky', top: '-1%' }}>
                                                <tr>
                                                    <th style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
                                                        <input
                                                            type="checkbox"
                                                            checked={Object.keys(this.state.studentList).length > 0 && (Object.keys(this.state.studentList).length == this.state.selectedStudentIds.length)}
                                                            onChange={(e) => this.selectAllStudents(e)}
                                                            style={{ marginRight: 5 }}
                                                        />
                                                    </th>
                                                    <th style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>Sr.No.</th>
                                                    <th style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>ERP Id</th>
                                                    <th style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>First Name</th>
                                                    <th style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>Last Name</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {
                                                    this.state.accessDataList ?
                                                        <tr>
                                                            <Spinner />
                                                        </tr>
                                                        :
                                                        Object.values(this.state.studentList).length > 0 ?
                                                            Object.values(this.state.studentList).map((student, index) => {

                                                                return (
                                                                    <>
                                                                        <tr>
                                                                            <th style={{ paddingBottom: '4px' }}>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={this.state.selectedStudentIds.includes(student.studentId.toString())}
                                                                                    onChange={() => this.selectSingleStudent(student.studentId.toString())}
                                                                                    style={{ marginRight: 5 }}
                                                                                />
                                                                            </th>
                                                                            <td className="tableRows">{this.state.offset + index + 1}</td>
                                                                            <td className="tableRows">{student["studentUserId"]}</td>
                                                                            <td className="tableRows">{student["studentFirstName"]}</td>
                                                                            <td className="tableRows">{student["studentLastName"]}</td>

                                                                        </tr>
                                                                    </>
                                                                )
                                                            })
                                                            :
                                                            <tr>
                                                                <td colSpan={6}>Students not found</td>
                                                            </tr>
                                                }
                                            </tbody>
                                        </table>
                                    )
                                }

                            </div>
                        )
                        }
                    </div>

                    <div className="col-md-12 pt-3">
                        <div className="row">
                            <div className="col-md-6">
                                <label style={{ fontWeight: "bold", fontSize: "14px" }}>Validity From<span style={{ color: 'red' }}> *</span></label>

                                <input
                                    type="date"
                                    className="form-control"
                                    style={{ width: "100%", paddingLeft: "10px" }}
                                    value={this.state.validFromDate}
                                    onChange={(e) => this.setState({ validFromDate: e.target.value })}
                                    disabled={this.state.selectedFacultyIds.length == 0 && this.state.selectedStudentIds.length == 0}

                                />
                            </div>
                            <div className="col-md-6">
                                <label style={{ fontWeight: "bold", fontSize: "14px" }}>Validity Till<span style={{ color: 'red' }}> *</span></label>

                                <input
                                    type="date"
                                    className="form-control"
                                    style={{ width: "100%", paddingLeft: "10px" }}
                                    value={this.state.validToDate}
                                    onChange={(e) => this.setState({ validToDate: e.target.value })}
                                    disabled={this.state.selectedFacultyIds.length == 0 && this.state.selectedStudentIds.length == 0}

                                />
                            </div>
                        </div>
                        <div className='text-danger font-weight-normal' style={{ paddingLeft: '2%', paddingTop: '2%', fontSize: '13px' }}>
                            {
                                (!this.state.validFromDate && this.state.isDateEmpty)
                                && 'Please select a valid start date.'
                            }
                            {
                                (this.state.isDateEmpty && !this.state.validToDate.length)
                                && 'Please select a valid end date.'
                            }
                            {
                                this.state.validFromDate && this.state.validToDate &&
                                this.state.validToDate < this.state.validFromDate &&
                                'Valid till date must be on or after valid from date.'
                            }
                        </div>
                    </div>

                    <div id="addAccessFooter" className="modal-footer pt-3">
                        {/* {
                            this.state.addingAccess &&
                            <Spinner />
                        } */}
                        <button className="btn btn-outline-primary waves-effect" onClick={() => this.closeAddMember()}>Cancel</button>
                        <button className="btn btn-primary"
                            disabled={!this.state.validFromDate && !this.state.validToDate}
                            onClick={() => this.validateMembers()}
                        >Register As Member</button>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO RETURN ADVANCED FILTERS
    returnAdvancedFilterModal = () => {
        return (
            <div id="addAccessSideMenu" style={{ display: this.state.filterModal ? 'flex' : 'none' }}>
                <div id="addMemberDataContainer">
                    <div id="addAccessHeader" className="row">
                        <FontAwesomeIcon icon={['fas', 'times']} size="lg" color="#000" onClick={() => this.closeAdvancedFilter()} style={{ cursor: "pointer" }} />
                        <h5 style={{ paddingLeft: '30%' }} className="col-11">Advanced Filters</h5>
                    </div>
                    <div>
                        <div className="col-md-12 pt-3 pb-3">
                            <div className="row">
                                <div className="col-md-6">
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>Membership</label>

                                    <select className="form-control"
                                        // style={{ height: '4vh' }}
                                        name="role"
                                        id="role"
                                        value={this.state.searchMemberStatus}
                                        onChange={this.handleStatusChange}
                                    >
                                        <option value="">Select Membership Status</option>
                                        <option value="active">Active</option>
                                        <option value="expired">Expired</option>
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label style={{ fontWeight: "bold", fontSize: "14px" }}>Role</label>

                                    <select className="form-control"
                                        // style={{ height: '4vh' }}
                                        name="role"
                                        id="role"
                                        value={this.state.searchMemberRole}
                                        onChange={this.filterRoleChange}
                                    >
                                        <option value="">Select Role</option>
                                        <option value="student">Student</option>
                                        <option value="faculty">Faculty</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 pt-4">
                            <div className="row">
                                <div className="col-md-6">
                                    {
                                        this.state.searchMemberRole == 'student' && (

                                            <>
                                                <label style={{ fontWeight: "bold", fontSize: "14px" }}>Academic Year</label>

                                                <select className="form-control"
                                                    // style={{ height: '4vh' }}
                                                    value={this.state.searchMemberAcaYr}
                                                    onChange={(e) => { this.setState({ searchMemberAcaYr: e.target.value }) }}
                                                >
                                                    <option value="">Select Year</option>
                                                    {
                                                        Object.values(config.academicInfo).map(acaYr => {
                                                            return (
                                                                <option value={acaYr.YearId}>{acaYr.YearText}</option>
                                                            );
                                                        })
                                                    }
                                                </select>
                                            </>
                                        )
                                    }
                                    {
                                        this.state.searchMemberRole == 'faculty' && (
                                            <>
                                                <label style={{ fontWeight: "bold", fontSize: "14px" }}>Department</label>

                                                <select className="form-control"
                                                    // style={{ height: '4vh' }}
                                                    value={this.state.searchMemberDepartment}
                                                    onChange={(e) => { this.setState({ searchMemberDepartment: e.target.value }, () => { this.apiCallToGetEmployeeDetails(); }) }}
                                                >
                                                    <option value="">Select Department</option>
                                                    {
                                                        Object.keys(this.state.facultyDepartment).map(streams => {
                                                            let streamNames = this.state.facultyDepartment[streams]

                                                            return (
                                                                <option value={streams}>{streamNames.stream_name}</option>
                                                            );
                                                        })
                                                    }
                                                </select>

                                            </>
                                        )
                                    }
                                </div>
                                <div className="col-md-6">
                                    {
                                        this.state.searchMemberRole == 'student' && (
                                            <>
                                                <label style={{ fontWeight: "bold", fontSize: "14px" }}>Department</label>

                                                <select className="form-control"
                                                    // style={{ height: '4vh' }}
                                                    value={this.state.searchMemberDepartment}
                                                    onChange={(e) => { this.setState({ searchMemberDepartment: e.target.value }, () => { this.apiCallToGetSemesterDetails("filter"); }) }}
                                                >
                                                    <option value="">Select Department</option>
                                                    {
                                                        Object.keys(this.state.facultyDepartment).map(streams => {
                                                            let streamName = this.state.facultyDepartment[streams]

                                                            return (
                                                                <option value={streams}>{streamName.stream_name}</option>
                                                            );
                                                        })
                                                    }
                                                </select>
                                            </>
                                        )
                                    }
                                </div>
                                <div className="col-md-6 pt-4">
                                    {
                                        this.state.searchMemberRole == 'student' && (
                                            <div>
                                                <label style={{ fontWeight: "bold", fontSize: "14px" }}>Group</label>

                                                <select className="form-control"
                                                    // style={{ height: '4vh' }}
                                                    value={this.state.searchMemberGroup}
                                                    onChange={(e) => { this.setState({ searchMemberGroup: e.target.value }) }}
                                                    disabled={!(this.state.searchMemberDepartment && this.state.searchMemberAcaYr)}
                                                >
                                                    <option value="">Select Group</option>
                                                    {
                                                        Object.keys(this.state.semesterList).map(groupList => {
                                                            let groupName = this.state.semesterList[groupList]

                                                            return (
                                                                <option value={groupList}>{groupName.title}</option>
                                                            );
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    <div id="addAccessFooter" className="modal-footer pt-3">
                        {/* {
                            this.state.addingAccess &&
                            <Spinner />
                        } */}
                        <button className="btn btn-primary" onClick={() => this.applyAdvancedFilter()}>Apply</button>
                        <button className="btn btn-outline-primary waves-effect" onClick={() => this.clearFilter()}>Clear</button>
                    </div>
                </div>
            </div>
        );
    }

    // METHOD TO CHECK EDIT ACCESS
    updateMembershipModal = () => {

        const editGrantAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['membership'].find(access => access === 'edit');

        if (editGrantAccess !== undefined) {
            this.setState({
                renewMembershipModal: true
            });
        }
        else {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    openActivitySlider = (id) => {
        this.setState({
            selectedIid: id,
            showActivitySlider: true
        });
    };

    closeActivitySlider = () => {
        this.setState({
            selectedIid: "",
            showActivitySlider: false
        });
    };

    render() {

        return (
            <>

                {/* Modal to Renew Membership */}
                <div className={this.state.renewMembershipModal ? "modal fade show" : "modal fade"} id="modalContainer" >
                    <div class="modal-dialog modal-dialog-centered" style={{ maxWidth: '42VW', minHeight: "calc(100% - 10.5rem)" }}>
                        <div class="modal-content">
                            <div class="modal-header" style={{ padding: '10px', backgroundColor: '#0465ac', color: 'white' }}>
                                <h5 class="modal-title">Renew Membership</h5>
                                <button style={{ color: '#FFFFFF' }} type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true" onClick={() => this.closeRenewModal()}>&times;</span>
                                </button>
                            </div>
                            <div class="modal-body pl-0 pr-0">
                                <div className="col-md-12">
                                    <p style={{ paddingLeft: '1%', backgroundColor: '#FBE7C6', fontSize: '14px' }}>Please note that the membership will be updated for <span>{this.state.selectedMemberIds.length}</span> selected entries</p>
                                    <div className="row pt-4 pb-4">
                                        <div className="col-md-6">
                                            <label style={{ fontWeight: "bold", fontSize: "14px" }}>Validity From<span style={{ color: 'red' }}> *</span></label>

                                            <input
                                                type="date"
                                                className="form-control"
                                                style={{ width: "100%", paddingLeft: "10px" }}
                                                value={this.state.updateValidFromDate}
                                                onChange={(e) => this.setState({ updateValidFromDate: e.target.value })}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label style={{ fontWeight: "bold", fontSize: "14px" }}>Validity Till<span style={{ color: 'red' }}> *</span></label>

                                            <input
                                                type="date"
                                                className="form-control"
                                                style={{ width: "100%", paddingLeft: "10px" }}
                                                value={this.state.updateValidToDate}
                                                onChange={(e) => this.setState({ updateValidToDate: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='text-danger font-weight-normal' style={{ paddingLeft: '4%', fontSize: '13px' }}>
                                    {
                                        (!this.state.updateValidFromDate && this.state.isDateEmpty)
                                        && 'Please select a valid start date.'
                                    }
                                    {
                                        (this.state.isDateEmpty && !this.state.updateValidToDate.length)
                                        && 'Please select a valid end date.'
                                    }
                                    {
                                        this.state.updateValidFromDate && this.state.updateValidToDate &&
                                        this.state.updateValidToDate < this.state.updateValidFromDate &&
                                        'Valid till date must be on or after valid from date.'
                                    }
                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-outline-primary" data-dismiss="modal" onClick={() => this.closeRenewModal()}>Cancel</button>
                                <button type="button" class="btn btn-primary" onClick={() => this.validateRenewMembership()} >Update Membership</button>
                            </div>
                        </div>
                    </div>
                </div>

                <RoutingMenu activeScreen="membership" />
                <div className="libraryComponents-container">
                    <div className="pb-5">
                        <div className="pl-3 pt-1 pb-2">
                            <h4>Membership</h4>
                        </div>
                        <div className="pl-1 pt-4 col-md-12">
                            <div className="row d-flex justify-content-between">
                                <span className="col-md-8">
                                    <div className="row">
                                        <input
                                            type="text"
                                            className="form-control"
                                            style={{ width: '30%', fontSize: '14px', paddingLeft: '10px', paddingTop: '6px', paddingBottom: '6px' }}
                                            placeholder="Search by ERP Id"
                                            value={this.state.searchMemberUserID} // Use the value prop to control the input
                                            onChange={(e) => this.setState({ searchMemberUserID: e.target.value })}
                                            onKeyPress={(e) => this.setState({ searchMemberUserID: e.target.value, pageIndex: 1, offset: 0, filterApplied: true }, () => { this.apiCallToGetLibraryMembersList() })}
                                        /> &nbsp;&nbsp;&nbsp;&nbsp;
                                        <div style={{ paddingTop: '10px', fontSize: "14px", textDecoration: 'underline', color: '#0080ff', cursor: 'pointer' }}
                                            onClick={() => this.setState({ filterModal: true })}
                                        >
                                            + Advanced Filters <FontAwesomeIcon icon={["fa", "filter"]} />
                                        </div>
                                    </div>
                                </span>
                                <div>
                                    <button type="button" onClick={() => this.checkAddMember()} className="btn btn-primary">
                                        <FontAwesomeIcon icon={["fa", "plus"]} /> &nbsp;
                                        Register New Member
                                    </button>
                                </div>
                            </div>
                        </div>

                        {
                            this.state.filterApplied &&

                            (
                                <div className="row my-2">
                                    <div className="col-md-12">
                                        <div className="filter_container appliedFilteredDiv" style={{ background: "#FFF", display: "flex", alignItems: "end" }}>
                                            <div>
                                                <div style={{ paddingLeft: '15px' }}>
                                                    <label style={{ fontSize: 12, marginBottom: 0 }}>Applied Filters</label>
                                                    <div style={{ display: "flex", gap: 10, overflowX: "auto" }}>

                                                        {this.state.searchMemberStatus.length > 0 && <div class="appliedFilters"><span>Membership Status</span><span><FontAwesomeIcon icon={['fas', 'times']} onClick={() => { this.setState({ searchMemberStatus: "" }, () => this.apiCallToGetLibraryMembersList()) }} style={{ cursor: "pointer" }} /></span></div>}

                                                        {this.state.searchMemberAcaYr.length > 0 && <div class="appliedFilters"><span>Academic Year</span><span><FontAwesomeIcon icon={['fas', 'times']} onClick={() => { this.setState({ searchMemberAcaYr: "" }, () => this.apiCallToGetLibraryMembersList()) }} style={{ cursor: "pointer" }} /></span></div>}

                                                        {this.state.searchMemberDepartment.length > 0 && <div class="appliedFilters"><span>Department</span><span><FontAwesomeIcon icon={['fas', 'times']} onClick={() => { this.setState({ searchMemberDepartment: "", searchMemberGroup: "" }, () => this.apiCallToGetLibraryMembersList()) }} style={{ cursor: "pointer" }} /></span></div>}

                                                        {this.state.searchMemberGroup.length > 0 && <div class="appliedFilters"><span> Group</span><span><FontAwesomeIcon icon={['fas', 'times']} onClick={() => { this.setState({ searchMemberGroup: "" }, () => this.apiCallToGetLibraryMembersList()) }} style={{ cursor: "pointer" }} /></span></div>}

                                                        {this.state.searchMemberRole.length > 0 && <div class="appliedFilters"><span>Role</span><span><FontAwesomeIcon icon={['fas', 'times']} onClick={() => { this.setState({ searchMemberRole: "" }, () => this.apiCallToGetLibraryMembersList()) }} style={{ cursor: "pointer" }} /></span></div>}

                                                        {this.state.searchMemberUserID.length > 0 && <div class="appliedFilters"><span>ERP Id</span><span><FontAwesomeIcon icon={['fas', 'times']} onClick={() => { this.setState({ searchMemberUserID: "" }, () => this.apiCallToGetLibraryMembersList()) }} style={{ cursor: "pointer" }} /></span></div>}

                                                    </div>
                                                </div>
                                            </div>
                                            <div >
                                                <span
                                                    className="mt-3 clearContainer"
                                                    title="Click to clear filters"
                                                    style={{ fontSize: 13, color: '#007bff', cursor: 'pointer', fontWeight: 'bold' }}
                                                    onClick={() => this.setState({ filterApplied: false, searchMemberStatus: "", searchMemberAcaYr: "", searchMemberDepartment: "", searchMemberGroup: "", searchMemberRole: "", searchMemberUserID: "" }, () => this.apiCallToGetLibraryMembersList())}
                                                >
                                                    <span className='clearIcon'>
                                                        <FontAwesomeIcon icon={['fas', 'brush']} style={{ transform: "rotate(180deg)" }} />
                                                    </span> &nbsp;&nbsp;
                                                    <span style={{ textDecoration: "underline" }}>
                                                        Clear Filters
                                                    </span>
                                                </span>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </div>

                    <div className="pl-3 pr-3  table-responsive col-md-12" style={{ maxHeight: '55vh', overflowY: 'auto' }}>
                        <table class="table jumbotron">
                            <thead style={{ backgroundColor: "#f2f3f4", position: 'sticky', top: '-1%' }}>
                                <tr>
                                    <th>
                                        <input
                                            type="checkbox"
                                            checked={Object.keys(this.state.membersList).length > 0 && (Object.keys(this.state.membersList).length == this.state.selectedMemberIds.length)}
                                            onChange={(e) => this.selectAllMembers(e)}
                                            style={{ marginRight: 5 }}
                                        />
                                    </th>
                                    <th scope="col">Sr. No.</th>
                                    <th scope="col">Role</th>
                                    <th scope="col">ERP ID</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Academic Year</th>
                                    <th scope="col">Department</th>
                                    <th scope="col">Group</th>
                                    <th scope="col">Validity</th>
                                    <th scope="col">Membership Status</th>
                                    <th scope="col">Added By</th>
                                    <th scope="col">Last Modified By</th>
                                </tr>

                                {
                                    this.state.selectedMemberIds.length > 0 &&
                                    <tr style={{ backgroundColor: "#eff7ff" }}>
                                        <th colSpan="13" style={{ padding: '10px' }}>
                                            <div className="">
                                                {/* <button  type="button" style={{ height: '2.375rem' }} className="btn btn-outline-primary p-2" title="Click to register as member" onClick={() => this.setState({ cancelEvent: true })}>
                                                    Register As Member
                                                </button> */}
                                                {/* <button type="button" style={{ height: '2.375rem' }} className="btn btn-outline-primary p-2" title="Click to renew membership" onClick={() => this.updateMembershipModal()}>
                                                    Renew Membership
                                                </button> */}
                                                <span id="renewMembership" title="Click to renew membership" onClick={() => this.updateMembershipModal()}>
                                                    Renew Membership
                                                </span>
                                            </div>
                                        </th>
                                    </tr>
                                }

                            </thead>
                            <tbody>
                                {
                                    this.state.accessMemberList ?
                                        <tr>
                                            <Spinner />
                                        </tr>
                                        :
                                        Object.keys(this.state.membersList).length > 0 ?
                                            Object.values(this.state.membersList).reverse().map((members, index) => {

                                                // format added on date
                                                const inputDate = members.addedOn;
                                                const date = moment(inputDate, 'YYYY-MM-DD HH:mm:ss');
                                                const addedOnDate = date.format('Do MMM, YYYY | h:mm A | dddd');
                                                const inputUpdatedDate = members.updated_on;
                                                const dateUpdate = moment(inputUpdatedDate, 'YYYY-MM-DD HH:mm:ss');
                                                const updatedOnDate = dateUpdate.format('Do MMM, YYYY | h:mm A | dddd');

                                                //format validfrom and valid to date
                                                const startDate = moment(members.valid_from);
                                                const endDate = moment(members.valid_to);

                                                const formattedStartDate = startDate.format('Do MMM, YYYY');
                                                const formattedEndDate = endDate.format('Do MMM, YYYY');

                                                // handle role and updated on
                                                let role = "";
                                                let updatedOn = "";

                                                if (members.memberRole == "faculty") {
                                                    role = "Faculty";
                                                } else {
                                                    role = "Student";
                                                }

                                                if (members.updated_on === "0000-00-00 00:00:00") {
                                                    updatedOn = "";
                                                } else {
                                                    updatedOn = updatedOnDate
                                                }

                                                // to set validity status
                                                const validToDate = new Date(members.valid_to);

                                                const validTill = moment(new Date(members.valid_to)).startOf('day');
                                                const today = moment(new Date()).startOf('day');

                                                let status = "";
                                                if (validTill.isBefore(today)) {
                                                    status = 'Expired';
                                                } else {
                                                    status = 'Active';
                                                }

                                                return (
                                                    <>
                                                        <tr>
                                                            <th style={{ padding: '0.5rem' }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={this.state.selectedMemberIds.includes(members.unique_id.toString())}
                                                                    onChange={() => this.selectSingleMember(members.unique_id.toString())}
                                                                    style={{ marginRight: 5 }}
                                                                />
                                                            </th>
                                                            <td style={{ padding: '0.5rem' }}>{this.state.offset + index + 1}</td>
                                                            <td style={{ padding: '0.5rem' }}>{role}</td>
                                                            <td style={{ padding: '0.5rem' }}>{members.memberERPId ? members.memberERPId : "-"}</td>
                                                            <td style={{ padding: '0.5rem' }}>{members.memberSalutation ? members.memberSalutation : ""}&nbsp;{members.memberName}</td>
                                                            <td style={{ padding: '0.5rem' }}>{members.academicYear ? members.academicYear : "-"}</td>
                                                            <td style={{ padding: '0.5rem' }}>{members.streamName}</td>
                                                            <td style={{ padding: '0.5rem' }}>{members.groupName ? members.groupName : "-"}</td>
                                                            <td style={{ padding: '0.5rem' }}>
                                                                <p>{formattedStartDate} - {formattedEndDate}</p>
                                                            </td>
                                                            <td style={{ padding: '0.5rem' }}>
                                                                <span style={{ padding: "8px", color: status === 'Active' ? 'green' : 'red' }}>{status}</span>
                                                            </td>
                                                            <td style={{ padding: '0.5rem' }}>
                                                                <p title={addedOnDate}>{members.addedByName}</p>
                                                                {/* <p>{addedOnDate}</p> */}
                                                            </td>
                                                            <td style={{ padding: '0.5rem', cursor: "pointer", color: members.unique_id == this.state.hoverID ? "#0465AC" : "" }}
                                                                onMouseEnter={() => this.setState({ hoverID: members.unique_id })}
                                                                onMouseLeave={() => this.setState({ hoverID: "" })}
                                                                onClick={() => this.openActivitySlider(members.unique_id)}>
                                                                <p title={updatedOn}>
                                                                    {members.updatedByName
                                                                        ? `${members.updatedByName} (${members.last_updated_by_ERP}) | ${members.updated_On}`
                                                                        : '-'}
                                                                </p>
                                                                {/* <p>{updatedOn}</p> */}
                                                            </td>
                                                        </tr>

                                                    </>
                                                );
                                            })
                                            :
                                            <tr>
                                                <td style={{ padding: 5 }} colSpan={13}>No member registered is added yet. Please click on 'Register New Member' to register member.</td>
                                            </tr>
                                }
                            </tbody>
                        </table>
                    </div>

                    <div className="pl-3 pr-4">
                        <div style={{ display: 'flex', justifyContent: "space-between", alignItems: 'center', flexWrap: "nowrap", marginBottom: 15 }}>
                            <div className="perPageSelectContainer" style={{ fontSize: 13, fontWeight: "bold" }}>
                                <span >Show</span>
                                <select
                                    className="mx-2"
                                    value={this.state.limit}
                                    onChange={(e) => this.selectLimit(e)}
                                >
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={40}>40</option>
                                    <option value={100}>100</option>
                                    <option value={250}>250</option>
                                </select>
                                <span>entries</span>
                            </div>

                            <div id="paginationContainer">
                                <Pagination
                                    activePage={this.state.pageIndex}
                                    itemsCountPerPage={this.state.limit}
                                    totalItemsCount={this.state.totalMembers}
                                    pageRangeDisplayed={3}
                                    onChange={(num) => this.updatePaginationCount(num)}
                                />
                            </div>

                            <p className="mx-2" style={{ fontWeight: 'bold', fontSize: 13 }}>Total Records : {this.state.totalMembers} </p>
                        </div>
                    </div>



                </div>
                {
                    this.returnRegisterNewMember()
                }
                {
                    this.returnAdvancedFilterModal()
                }
                {
                    this.state.successModal &&
                    <SuccessModal
                        successModal={this.state.successModal}
                        successModalType={this.state.successModalType}
                        successMessage={this.state.successMessage}
                        closeSuccessModal={this.closeSuccessModal}
                    />
                }
                {
                    this.state.showActivitySlider && this.state.selectedIid != "" &&
                    <SpecificUserLog
                        showSlider={this.state.showActivitySlider}
                        closeSlider={this.closeActivitySlider}
                        logUid={this.state.selectedIid}
                        activityArr={["member_added", "Membership_updated"]}
                    />
                }
            </>
        )
    }

}
const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations: store.RouteMenuReducer.accessibleOperations,
        isAdmin: store.RouteMenuReducer.isLibraryAdmin
    };
};

export default connect(mapStateToProps)(Membership);
